import { Alert } from '@/types/types';
import { AlertState, RootState } from '@/types/store';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';

// initial state
const state: AlertState = {
  alert: null
};

// getters
// Here to let other component access store data
const getters: GetterTree<AlertState, RootState> = {
  alert: aState => aState.alert
};

// mutations
// Here to let other component change store data
const mutations: MutationTree<AlertState> = {
  addAlert(alertState, newAlert: Alert): void {
    alertState.alert = {
      message: newAlert.message,
      time: newAlert.time,
      type: newAlert.type
    };
  },
  clearAlert(alertState): void {
    alertState.alert = null;
  }
};

// actions
// Here goes services calls
const actions: ActionTree<AlertState, RootState> = {
  async addAlert({ commit }, alert: Alert) {
    commit('addAlert', alert);
  },
  async clearAlert({ commit }) {
    commit('clearAlert');
  }
};

export const alert: Module<AlertState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
